!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));else if ("function" == typeof define && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js"], t);else {
    var n = "object" == typeof exports ? t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : t(e.react, e.classnames, e["@material/react-ripple/dist/index.js"]);
    for (var r in n) ("object" == typeof exports ? exports : e)[r] = n[r];
  }
}("undefined" != typeof self ? self : this, function (e, t, n) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 45);
  }({
    0: function (t, n) {
      t.exports = e;
    },
    1: function (e, n) {
      e.exports = t;
    },
    45: function (e, t, n) {
      "use strict";

      var r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }).apply(this, arguments);
        },
        o = this && this.__rest || function (e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        },
        i = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var l = i(n(0)),
        u = i(n(1)),
        a = n(5),
        s = n(46);
      t.Button = function (e) {
        var t,
          n = e.className,
          i = void 0 === n ? "" : n,
          a = e.raised,
          d = void 0 !== a && a,
          f = e.unelevated,
          p = void 0 !== f && f,
          S = e.outlined,
          b = void 0 !== S && S,
          m = e.dense,
          y = void 0 !== m && m,
          E = e.disabled,
          _ = void 0 !== E && E,
          v = e.icon,
          O = e.href,
          j = e.children,
          C = e.initRipple,
          h = e.trailingIcon,
          x = (e.unbounded, o(e, ["className", "raised", "unelevated", "outlined", "dense", "disabled", "icon", "href", "children", "initRipple", "trailingIcon", "unbounded"])),
          L = r({
            className: u.default(s.CSS_CLASSES.ROOT, i, (t = {}, t[s.CSS_CLASSES.RAISED] = d, t[s.CSS_CLASSES.UNELEVATED] = p, t[s.CSS_CLASSES.OUTLINED] = b, t[s.CSS_CLASSES.DENSE] = y, t)),
            ref: C,
            disabled: _
          }, x);
        return O ? l.default.createElement("a", r({}, L, {
          href: O
        }), h ? null : c(v), l.default.createElement("span", {
          className: s.CSS_CLASSES.LABEL
        }, j), h ? c(h) : null) : l.default.createElement("button", r({}, L), h ? null : c(v), l.default.createElement("span", {
          className: s.CSS_CLASSES.LABEL
        }, j), h ? c(h) : null);
      };
      var c = function (e) {
        return e ? l.default.cloneElement(e, {
          className: u.default(s.CSS_CLASSES.ICON, e.props.className)
        }) : null;
      };
      t.Button.defaultProps = {
        initRipple: function () {}
      }, t.default = a.withRipple(t.Button);
    },
    46: function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      t.CSS_CLASSES = {
        ROOT: "mdc-button",
        ICON: "mdc-button__icon",
        LABEL: "mdc-button__label",
        DENSE: "mdc-button--dense",
        RAISED: "mdc-button--raised",
        OUTLINED: "mdc-button--outlined",
        UNELEVATED: "mdc-button--unelevated"
      };
    },
    5: function (e, t) {
      e.exports = n;
    }
  });
});